import { toJS, observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
// import { formatCateTree } from '../../utils/common'
const { supplier } = api;

class SupplierStore {
  @observable supplierList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @observable supplierDetailInfo = {};

  // 获取供应商列表
  @action async getSupplierList(params) {
    const { data } = await httpClient.post(supplier.GET_SUPPLIER_LIST, params);

    this.supplierList = {
      list: data?.list,
      pages: {
        total: data?.total,
        pageSize: params?.pageSize,
        currentPage: data?.page,
      },
    };
  }

  // 获取供应商详情
  @action async getSupplierDetail(params) {
    try {
      const { data } = await httpClient.get(supplier.GET_SUPPLIER_DETAIL, {
        params,
      });
      this.supplierDetailInfo = data;
      return data;
    } catch (error) {
      return false;
    }
  }

  // 校验账号
  @action async chechAccount(params) {
    const { data } = await httpClient.get(supplier.CHECK_ACCOUNT, { params });
    this.supplierDetailInfo = { supplierName: data.supplierName };
    return data;
  }

  // 添加&编辑供应商
  @action updateCate(params) {
    return params.isAdd
      ? httpClient.post(supplier.ADD_SUPPLIER, { ...params })
      : httpClient.post(supplier.EDIT_SUPPLIER, { ...params });
  }

  // 更改供应商启用状态
  @action async changeSupplierState(params) {
    const data = await httpClient.post(supplier.CHANGE_SUPPLIER_STATE, {
      ...params,
    });

    // 更改state.supplierList， 以更新页面展示
    const _newList = this.supplierList.list;
    _newList.filter((item) => item.supplierId === params.supplierId)[0].status =
      params.status;
    this.supplierList.list = toJS(_newList);

    return data;
  }

  // 更改卖家端启用状态
  @action async changeSupplierStatus(params) {
    return await httpClient.post(supplier.CHANGE_SUPPLIER_STATE, { ...params });
  }

  // 重置supplierDetail
  @action resetSupplierDetail() {
    this.supplierDetailInfo = {};
  }

  // 校验供应商手机号
  @action async checkSupplyMobile(params) {
    try {
      const { data } = await httpClient.get(supplier.CHECK_MOBILE, { params });
      return data;
    } catch (error) {
      return false;
    }
  }

  //校验会员账号
  @action async checkSupplyaccount(params) {
    try {
      const { data } = await httpClient.get(supplier.CHECK_SUPPLIER_ACCOUNT, {
        params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 添加供应商
  @action async addSupplier(params) {
    try {
      const { success } = await httpClient.post(supplier.ADD_SUPPLIER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 编辑供应商
  @action async updateSupplier(params) {
    try {
      const { success } = await httpClient.post(supplier.EDIT_SUPPLIER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 根据供应商简称搜索供应商列表
  @action async getSupplierListByName(params) {
    try {
      const { data } = await httpClient.get(
        supplier.GET_SUPPLIER_LIST_BY_NAME,
        { params }
      );
      const list = data.list || [];
      return list;
    } catch (error) {
      return false;
    }
  }

  // 根据企业名称搜索企业列表
  @action async getCompanyListByName(params) {
    try {
      const { data } = await httpClient.post(
        supplier.GET_COMPANY_LIST_BY_NAME,
        { ...params }
      );
      const list = data.list || [];
      return list;
    } catch (error) {
      return false;
    }
  }
}

export default new SupplierStore();
